import { faChevronLeft, faChevronRight } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import LightGallery, { LightGalleryProps } from 'lightgallery/react'
import ReactDOMServer from 'react-dom/server'

export function LightGalleryWrapper({ ...props }: LightGalleryProps) {
  const onOpen = () => {
    document.body.classList.add('overflow-hidden')
  }

  const onClose = () => {
    document.body.classList.remove('overflow-hidden')
  }

  const nextButton = ReactDOMServer.renderToStaticMarkup(<FontAwesomeIcon icon={faChevronRight} />)
  const prevButton = ReactDOMServer.renderToStaticMarkup(<FontAwesomeIcon icon={faChevronLeft} />)

  const LIGHT_GALLERY_LICENSE_KEY = process.env['NEXT_PUBLIC_LIGHT_GALLERY_KEY'] as string

  return (
    <LightGallery
      licenseKey={LIGHT_GALLERY_LICENSE_KEY}
      dynamic={true}
      onAfterOpen={onOpen}
      onAfterClose={onClose}
      prevHtml={prevButton}
      nextHtml={nextButton}
      appendSubHtmlTo=".lg-outer"
      appendCounterTo=".lg-content"
      speed={100}
      backdropDuration={100}
      startAnimationDuration={100}
      actualSize={false}
      {...props}
    />
  )
}
